import { FC } from 'react';
import clsx from 'clsx';
import { useTable, Props } from './useTable';
import styles from './Table.module.css';

export const Table: FC<Props> = (props) => {
  const { data, type = 'horizontal' } = useTable(props);

  if (type === 'vertical') {
    return (
      <div className={styles.wrapper}>
        <table>
          {data.head.map((item, i) => {
            return (
              <tr key={i} className={styles.verticalLine}>
                <th className={clsx(styles.head, styles.th)}>{item.title}</th>
                <td
                  className={styles.td}
                  dangerouslySetInnerHTML={{
                    __html: data.body[i][0].value ?? ''
                  }}>
                </td>
              </tr>);

          })}
        </table>
      </div>);

  }

  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead className={styles.head}>
          <tr>
            {data.head.map((item, i) => {
              return (
                <th className={clsx(styles.th, item.className)} key={i}>
                  {item.title}
                </th>);

            })}
          </tr>
        </thead>
        <tbody className={styles.body}>
          {data.body.map((row, rowI) => {
            return (
              <tr key={rowI}>
                {row.map((col, colI) => {
                  return (
                    <td className={styles.td} key={colI}>
                      {col.value}
                    </td>);

                })}
              </tr>);

          })}
        </tbody>
      </table>
    </div>);

};